import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';
import LeadForm from "../widgets/forms/widget-action-form.js";
import logo from "../assets/Images/sfl-logo.png";

const Navbar = () => {
  const defaultIvrNumber = "+91 90 1540 1540";
  const secondIvrNumber = "+91 90 1570 6707";
  const thirdIvrNumber = "+91 70 2618 1010";

  // Page patterns
  const kolkataPagesPattern = /hearing-aids-(price|centre|info)-kolkata/;
  const gurgaonPagesPattern = /hearing-aids-(price|centre|info)-gurgaon/;
  const punjabPagePattern = /hearing-aids-centre-punjab/;

  const [phoneNumber, setPhoneNumber] = useState(defaultIvrNumber);
  const [isPunjabPage, setIsPunjabPage] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname.toLowerCase();
    const referrerPath = document.referrer
      ? new URL(document.referrer).pathname.toLowerCase()
      : "";

    const isThankYouPage =
      currentPath.includes("thankyou") || currentPath.includes("thank-you");

    // Punjab check
    setIsPunjabPage(punjabPagePattern.test(currentPath));

    // Kolkata checks
    const isKolkataPage = kolkataPagesPattern.test(currentPath);
    const isKolkataThankYouPage =
      isThankYouPage &&
      (kolkataPagesPattern.test(referrerPath) || currentPath.includes("kolkata"));

    // Gurgaon checks
    const isGurgaonPage = gurgaonPagesPattern.test(currentPath);
    const isGurgaonThankYouPage =
      isThankYouPage &&
      (gurgaonPagesPattern.test(referrerPath) || currentPath.includes("gurgaon"));

    if (isKolkataPage || isKolkataThankYouPage) {
      setPhoneNumber(secondIvrNumber);
    } else if (isGurgaonPage || isGurgaonThankYouPage) {
      setPhoneNumber(thirdIvrNumber);
    } else {
      setPhoneNumber(defaultIvrNumber);
    }

    if (isThankYouPage) {
      const timer = setTimeout(() => {
        window.location.href = "/";
      }, 40000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
        <div className="container d-flex justify-content-between align-items-center">

          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src={logo}
              alt="SFL Logo"
              style={{ height: "60px" }}
            />
          </a>

          {/* Desktop CTA */}
          {isPunjabPage ? (
  <button
    onClick={() => setIsFormOpen(true)}
    className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold"
  >
    Book a Hearing Aid Demo
  </button>
) : (
  <a
    href={`tel:${phoneNumber}`}
    className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold"
  >
    <i className="fa-solid fa-phone"></i> {phoneNumber}
  </a>
)}

          {/* Mobile CTA */}
        {isPunjabPage ? (
  <button
    onClick={() => setIsFormOpen(true)}
    className="btn btn-custom fw-bold d-inline d-lg-none"
    style={{ fontSize: "14px", padding: "6px 12px" }}
  >
    Book a Hearing Aids Demo
  </button>
) : (
  <a
    href={`tel:${phoneNumber}`}
    className="btn btn-custom fw-bold d-inline d-lg-none"
    style={{ fontSize: "14px", padding: "6px 12px" }}
  >
    <i className="fa-solid fa-phone"></i> Call Us
  </a>
)}
{isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}

        </div>
      </nav>
    </header>
  );
};

export default Navbar;
